import { render } from "./ProjectDetailsPage.vue?vue&type=template&id=1d3e1503"
import script from "./ProjectDetailsPage.vue?vue&type=script&lang=js"
export * from "./ProjectDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__